import {LaneSelectResponse} from 'src/app/laneSelect/store';
import {guardedFetcher} from 'src/utils/guardedFetcher';

const prefix = 'crud/areas';

export const LaneSelectServices = {
  get: () => guardedFetcher.get<LaneSelectResponse>(prefix),
};
